import React, { useCallback } from 'react'
import { hooks } from '@front/volcanion'

import Callbacks from './callbacks'

const withContainer = Component => () => {
  const [file, setFile] = hooks.useFormState('file')
  const { openNotification } = hooks.useNotification()
  const navigate = hooks.useNavigate()

  const [upload] = hooks.useModelFunction('list', 'import')

  const onSubmit = useCallback(Callbacks.onSubmitHandler(upload, file, navigate, openNotification), [upload, file, navigate, openNotification])
  const importFile = useCallback(Callbacks.importFileHandler(setFile, openNotification), [setFile, openNotification])

  const mergedProps = {
    file_name: file?.name,
    importFile,
    onSubmit
  }

  return (
    <Component {...mergedProps} />
  )
}

export default withContainer
